import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoftwareManagement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1795_1834)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.67 7.83008L4 9.50008H6L4.33 11.1701",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.5 3.5H3.5V6.5H6.5V3.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 12.5H8",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.5 14.5H1.5V2.33C1.5 1.87 1.87 1.5 2.33 1.5H7.66C8.12 1.5 8.49 1.87 8.49 2.33V13.8579L8.5 14.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 13C13.3284 13 14 12.3284 14 11.5C14 10.6716 13.3284 10 12.5 10C11.6716 10 11 10.6716 11 11.5C11 12.3284 11.6716 13 12.5 13Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 14V13",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 10V9",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 11.5H14",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 11.5H10",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.3197 13.3197L13.6797 12.6797",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3547 10.3202L10.7147 9.68018",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.32 9.68018L13.68 10.3202",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.32 12.6802L10.68 13.3202",
				stroke: "black",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1795_1834",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSoftwareManagement;
